export enum DataSourceDefinitionPropertyType {
  Number = 'INT',
  String = 'STRING',
  Html = 'HTML',
  Reference = 'REFERENCE',
  Geolocation = 'GEOLOCATION',
  Country = 'COUNTRY',
  Boolean = 'BOOLEAN',
}